/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
 import { Component, OnInit, Output, OnChanges, Input, EventEmitter, ViewEncapsulation, ViewChild, SimpleChanges, AfterViewInit } from '@angular/core';
 import { CommonService } from '../../shared/services/common.service';
 import { NgForm } from '@angular/forms';
 import { COMPANY_CODES } from '../../config/constants';
 import moment from 'moment';
 import { PlanPeriodsService } from '../../shared/services/planperiods.service';
 import { ChangeSponsorService } from '../changesponsor/change-sponsor.service';
 import { TranslateService } from '@ngx-translate/core';
 import { ToastrService } from 'ngx-toastr';
 import { ChangeOrgDownlineConfirmationModalComponent } from './change-org-downline-confirmation-modal.component';
 import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
 import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

export class DownlineParticipantModel {
  clientID: string = '';
  firstName: string = '';
  lastName: string = '';
  orgID: string = '';
  orgName: string = '';
  newOrgID?: string = '';
  organizationSame? = false;
  hasRequiredError = false;
  newOrgUnit: any;
}

@Component({
  selector: 'app-change-organization-downline',
  templateUrl: './change-organization-downline.component.html',
  styleUrls: ['./change-organization-downline.component.scss'],
  providers: [ChangeSponsorService],
  encapsulation: ViewEncapsulation.None
})

export class ChangeOrganizationDownlineComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('orgUnitDownlineForm') orgUnitDownlineForm!: NgForm;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() organization: any;
  public titleMaxLimit: boolean = false;
  private currentDate: Date = new Date();
  private globalDateFormatVar: any = localStorage.getItem('globalDateFormat');
  public datePickerOptions: Partial<BsDatepickerConfig> = {
    dateInputFormat: this.globalDateFormatVar
      ? this.globalDateFormatVar.toUpperCase()
      : 'MMM DD, YYYY',
      adaptivePosition: false,
      showTodayButton: true,
      todayPosition: 'center'
  };
  public isChangeOrgUnitDownlineAccess = true;
  public hasRequiredError = false;
  public isFormSubmitted = false;
  public isOrgUnitDownlineChanged = false;
  public defaultSearchText = '';
  public orgUnitPayload: any = {};
  public periodDetails: any;
  public startPeriodDateInMillis: any;
  public companyCodes: any;
  public companyCode: any;
  public currentOrganization: any;
  public isCompanyConfigNone = false;
  public newOrganization: any;
  public organizationSame = false;
  public downlineHasSameOrg = false;
  public fromName: any = {};
  public changeOrgUnitObj: any = {};
  public hasChangeAccess = true;
  public showDownlineLeg = false;
  public orgUnitIndex!: number;
  public periodStartDateInMillis: any;
  public validationObj = {
    userMessage: '',
    state: ''
  };
  public participantDownlines: DownlineParticipantModel[] = [];
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(
    public modalService: BsModalService,
    public commonService: CommonService,
    private translate: TranslateService,
    private toastr: ToastrService,
    public planPeriodsService: PlanPeriodsService,
    public changeSponsorService: ChangeSponsorService
  ) {
    this.companyCodes = COMPANY_CODES;
    this.commonService.setHelpObj({
      header: this.getTranslationWithKey('COR') || '',
      menuId: 'COR',
      sections: [],
      lastSavedData: [],
      relatedLinks: [
        {
          label: this.getTranslationWithKey('FLP'),
          url: '/fieldsupport/distributorList/default'
        },
        {
          label: this.getTranslationWithKey('GLY'),
          url: '/genealogyHome/genealogy/default'
        }
      ]
    });
  }

  ngOnInit() {
    this.hasChangeAccess = this.commonService.hasFeatureAccess('Change OrganizationUnit Downline');
    const userInfo = this.commonService.getUserDetails();
    if (userInfo && userInfo.permissions && userInfo.permissions.details) {
      // const detailObj = userInfo.permissions.details.find((detailObj) => detailObj.code === 'COD');
      // if (detailObj != undefined) {
      //   if (detailObj.code === 'COD') {
      //     if (detailObj.permission.code === 'RAC') {
      //       this.isChangeOrgUnitDownlineAccess = false;
      //     }
      //   }
      // } else {
      //   this.isChangeOrgUnitDownlineAccess = false;
      // }
      this.isChangeOrgUnitDownlineAccess = true;
    }
    this.companyCode = this.commonService.getCompanyCode();
    this.isOrgUnitDownlineChanged = false;
    this.resetValidationErrorMessage();
    this.getPeriodDetails();
    this.orgDownlineID();
    /* MLM-2777 - start */
    const leadershipFunction = this.commonService.getGenealogyConfiguration();
    if (leadershipFunction) {
      this.isCompanyConfigNone = leadershipFunction.name === 'None';
    }
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.orgUnitPayload.periodClose = true;
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['organization'] && changes['organization'].currentValue) {
      this.defaultSearchText = changes['organization'].currentValue?.clientId;
      this.fromOrganizationSelected(changes['organization'].currentValue);
      // show movedownlineleg only for Leaders(BM,RM,TL Confirmed(Occasional))
      if (changes['organization'].currentValue.rank > 194) {
        this.showDownlineLeg = true;
        this.orgUnitPayload.moveEntireDownlineLeg = true;
      } else {
        this.orgUnitPayload.moveEntireDownlineLeg = false;
      }
    }
  }

  private getPeriodDetails() {
    this.planPeriodsService
      .getPeriod()
      .then(this.getPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getPeriodDetailsSH(response: any) {
    this.periodDetails = response;
    if (this.periodDetails) {
      this.checkPeriodClose();
    }
  }

  public checkPeriodClose() {
    if (this.orgUnitPayload.periodClose) {
      this.startPeriodDateInMillis = moment(
        this.periodDetails.currentPeriod && this.periodDetails.currentPeriod.endDate
      )
        .add(1, 'days')
        .valueOf();
      if(['TMES', 'KSES'].includes(this.companyCode)) {
        this.orgUnitPayload.effectiveDate = this.commonService.prepareBSEffectiveDateObj(this.startPeriodDateInMillis);
      } else {
        this.orgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.startPeriodDateInMillis);
      }
    } else {
      // VCE-26904 - Effective Date should be Period Start Date instead of the current date if Period close not selected
      if (this.periodDetails.currentPeriod && this.periodDetails.currentPeriod.startDate) {
        this.periodStartDateInMillis = moment(this.periodDetails.currentPeriod.startDate);
        if(['TMES', 'KSES'].includes(this.companyCode)) {
          this.orgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.currentDate.getTime());
        } else {
          this.orgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.periodStartDateInMillis);
        }
      }
    }
  }

  private resetValidationErrorMessage() {
    this.validationObj = {
      userMessage: '',
      state: ''
    };
  }

  ngAfterViewInit() {
    this.orgUnitDownlineForm?.control?.valueChanges.subscribe(() => {
      if (this.orgUnitDownlineForm?.form?.invalid) {
        this.hasRequiredError = this.commonService.hasRequiredError(this.orgUnitDownlineForm?.form?.controls);
      } else {
        this.isFormSubmitted = false;
        this.hasRequiredError = false;
      }
    });
  }

  public fromOrganizationSelected(event: any) {
    this.orgUnitPayload.fromOrgUnit = event;
    this.orgUnitIndex = event.orgUnitIndex;
    this.participantDownlines = [];
    // show movedownlineleg only for Leaders(BM,RM,TL Confirmed(Occasional))
    if (this.orgUnitPayload.fromOrgUnit.pinnedAs && this.orgUnitPayload.fromOrgUnit.pinnedAs.rank > 194) {
      this.showDownlineLeg = true;
      this.participantAndDownlineDetails(event?.clientId);
    }
    this.organizationTypeChange();
  }

  public toNewOrganizationSelected(event: any) {
    this.newOrganization = event.organizationalUnit;
  }

  public clearNewToOrgStructureFilter(event: any) {
    this.newOrganization = '';
  }

  public toOrganizationSelected(event: any, downlineParticipant: DownlineParticipantModel) {
    // this.orgUnitPayload.toOrgUnit = event;
    // if (this.orgUnitPayload.toOrgUnit !== undefined) {
    //   this.newOrganization = this.orgUnitPayload.toOrgUnit.organizationalUnit;
    //   this.setFullName(this.newOrganization);
    // }
    downlineParticipant.newOrgID = event?.clientId;
    downlineParticipant.newOrgUnit = event.organizationalUnit;
  }

  public clearToOrgStructureFilter(downlineParticipant: DownlineParticipantModel) {
    // this.orgUnitPayload.toOrgUnit = null;
    delete downlineParticipant.newOrgID;
    delete downlineParticipant.organizationSame;
    delete downlineParticipant.newOrgUnit;
  }

  private setEffectiveDate() {
    this.orgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(new Date().getTime());
  }

  public organizationTypeChange() {

    const fromOrgUnit = this.orgUnitPayload?.fromOrgUnit;

    if (!fromOrgUnit) {
      return;
    }

    this.currentOrganization =
      fromOrgUnit.organizationalUnit ??
      fromOrgUnit.organizationDetails?.[this.orgUnitIndex];

    if (!this.currentOrganization) {
      console.error('Current organization could not be resolved');
      return;
    }

    this.setFullName(this.currentOrganization);
  }

  public orgDownlineID(){
    const clientID = this.defaultSearchText;
    this.participantAndDownlineDetails(clientID);
  }

  private participantAndDownlineDetails(clientID: string) {
    this.participantDownlines = [];
    this.commonService
      .getParticipantAndDownlineDetails(clientID)
      .then(this.getParticipantAndDownlineDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getParticipantAndDownlineDetailsSH(response: any) {
    const result = response && response.downLineDetails ? response.downLineDetails : [];
    this.participantDownlines = JSON.parse(JSON.stringify(result));
  }

  public confimationPopUp() {
    const form = this.orgUnitDownlineForm?.form;
    let organizationUnit: any;
    this.isFormSubmitted = true;
    this.hasRequiredError = false;
    if (form?.invalid || !this.hasValidFormData()) {
      this.hasRequiredError = this.commonService.hasRequiredError(form?.controls) || !this.hasValidFormData();
    } else {
      this.isFormSubmitted = false;
      this.isOrgUnitDownlineChanged = false;
      if (this.orgUnitPayload.fromOrgUnit && this.orgUnitPayload.fromOrgUnit.organizationalUnit) {
        organizationUnit = this.orgUnitPayload.fromOrgUnit.organizationalUnit;
      } else {
        organizationUnit = this.orgUnitPayload.fromOrgUnit.organizationDetails[this.orgUnitIndex];
      }
      this.setFullName(organizationUnit);
      // this.setFullName(this.orgUnitPayload.toOrgUnit.organizationalUnit);
      this.setFullName(this.newOrganization);
      if (this.orgUnitPayload.fromOrgUnit) {
        const firstName = organizationUnit.firstName || '',
          lastName = organizationUnit.lastName || '';
        this.fromName.name = `${firstName} ${lastName}`;
      }
      const organizationData: any = {};
      organizationData['fromName'] = this.fromName.name;
      organizationData['orgUnitLbl'] = this.getTranslationWithKey('organization_unit_downline');
      organizationData['currentOrgUnitName'] = organizationUnit.orgUnitName;
      organizationData['clientID'] = this.orgUnitPayload.fromOrgUnit?.clientId;
      if (organizationUnit && organizationUnit.parentOrganizationalUnit) {
        organizationData['parentOrgUnitName'] = organizationUnit.parentOrganizationalUnit.orgUnitName;
      } else {
        organizationData['parentOrgUnitName'] = organizationUnit.orgUnitName;
      }
      organizationData['currentOrganization'] = this.currentOrganization;
      organizationData['newOrganization'] = this.newOrganization;
      organizationData['newDownlineOrganization'] = this.participantDownlines;
      const initialState = {
        context:{
          data: organizationData // Pass the organization data directly
        }
      };

      const modalRef: BsModalRef = this.modalService.show(ChangeOrgDownlineConfirmationModalComponent, {
        ...this.defaultConfig,
        initialState,
        class: 'modal-dialog modal-custom-width'
      });

      // Handle modal close event
      modalRef.content?.closeModal.subscribe((result: any) => {
        if (result) {
          this.changeOrgWithDownline(result);
        }
      });
    }
  }

  public changeOrgWithDownline(result: string) {
    if (result === 'confirmed') {
      let effectiveDate: any;
      if (this.orgUnitPayload.periodClose) {
        effectiveDate = this.startPeriodDateInMillis;
      } else {
        effectiveDate = this.periodStartDateInMillis;;
      }
      const payload: any = {
        comments: this.orgUnitPayload.comments,
        effectiveDate: effectiveDate,
        periodClose: !!this.orgUnitPayload.periodClose,
        moveEntireDownlineLeg: !!this.orgUnitPayload.moveEntireDownlineLeg,
        clientID: this.orgUnitPayload.fromOrgUnit?.clientId,
        toOrgId: this.newOrganization.orgUnitId
      };
      payload.downLineDetails = this.participantDownlines.map(record => {
        return {
          clientID: record.clientID,
          toOrgId: record.newOrgID
        }
      });
      this.changeSponsorService
        .changeOrgWithDownline(
          payload,
           this.orgUnitPayload.fromOrgUnit?.clientId,
          this.newOrganization.orgUnitId
        )
        .then(this.successHandler.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private successHandler(result: any) {
    if (this.orgUnitPayload.periodClose) {
      this.orgUnitPayload.toOrgUnit = this.orgUnitPayload.toOrgUnit;
    } else {
      this.orgUnitPayload.toOrgUnit = result;
    }
    this.commonService.setUpdateChangeOrgUnitList(result);
    this.resetValidationErrorMessage();
    this.isOrgUnitDownlineChanged = true;
    this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
  }

  private hasValidFormData() {
    this.organizationSame = false;
    this.downlineHasSameOrg = false;
    let organization: any;
    if (this.orgUnitPayload.fromOrgUnit && this.orgUnitPayload.fromOrgUnit.organizationalUnit) {
      organization = this.orgUnitPayload.fromOrgUnit.organizationalUnit;
    } else if (this.orgUnitPayload.fromOrgUnit && this.orgUnitPayload.fromOrgUnit.organizationDetails ) {
      organization = this.orgUnitPayload.fromOrgUnit.organizationDetails[this.orgUnitIndex];
    }
    // const cond =
    //   organization &&
    //   this.orgUnitPayload.toOrgUnit &&
    //   organization.orgUnitId !== this.orgUnitPayload.toOrgUnit.organizationalUnit.orgUnitId;
    // if (
    //   organization &&
    //   this.orgUnitPayload.toOrgUnit &&
    //   organization.orgUnitId == this.orgUnitPayload.toOrgUnit.organizationalUnit.orgUnitId
    // ) {
    //   this.organizationSame = true;
    // }

    const cond =
      organization && this.newOrganization &&
      this.newOrganization.orgUnitId &&
      organization.orgUnitId !== this.newOrganization.orgUnitId;
    if (
      organization && this.newOrganization &&
      this.newOrganization.orgUnitId &&
      organization.orgUnitId == this.newOrganization.orgUnitId
    ) {
      this.organizationSame = true;
    }

    if (!cond) {
      return false;
    } else {
      let result = true;
      for(const pdl of this.participantDownlines) {
        pdl.hasRequiredError = false;
        pdl.organizationSame = false;
        if (!pdl.newOrgID) {
          pdl.hasRequiredError = true;
          result = false;
          break;
        }else if (pdl.orgID === pdl.newOrgID) {
          pdl.organizationSame = true;
          this.downlineHasSameOrg = true;
          result = false;
          break;
        }
      }
      return result;
    }
  }

  private setFullName(organization: any) {
    if (organization) {
      const firstName = organization.orgUnitName || '';
      organization.name = `${firstName}`;
    }
  }

  public close() {
    this.isOrgUnitDownlineChanged = false;
    this.closeSlider.emit();
  }

  public clearOrgStructureFilter() {
    const effDate = this.orgUnitPayload.effectiveDate;
    this.currentOrganization = null;
    this.orgUnitPayload = {};
    this.orgUnitPayload.effectiveDate = effDate;
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.orgUnitPayload.periodClose = true;
    this.showDownlineLeg = false;
    this.orgUnitPayload.moveEntireDownlineLeg = true;
    this.checkPeriodClose();
  }

  public titleCommentsValidation(e: any) {
    this.titleMaxLimit = e.target.value.length == 100;
  }
}
